import timer_gen_2 from '@devices/settings/device_settings/timer_gen_2.js';
import schedule_gen_2 from '@devices/settings/device_settings/schedule_gen_2.js';
import networks_gen_2_pro from '@devices/settings/device_settings/networks_gen_2_pro.js';
import safety_gen_2 from '@devices/settings/device_settings/safety_gen_2.js';
import webhooks_gen_2 from '@devices/settings/device_settings/webhooks_gen_2.js';
import share from '@devices/settings/device_settings/share.js';
import bluetooth_gen_2 from '@devices/settings/device_settings/bluetooth_gen_2.js';

export default {
	name: 'Shelly4Pro',
	friendly_name: '4pro',
	family: 'relay',
	isPM: true,
	modes: {
		relay: {
			channels: 4,
			notifications: [
				'offline',
				'device_problem',
				'overpower',
				'overvoltage',
				'forgotten_lights',
				'overtemperature',
			],
			settings: [
				timer_gen_2,
				schedule_gen_2,
				networks_gen_2_pro,
				bluetooth_gen_2,
				safety_gen_2,
				{
					title: 'application_settings',
					components: [
						{ title: 'ai_model', component: 'ai_model' },
						{
							title: 'device_card_customization',
							component: 'customize_device_content',
						},
						{
							title: 'consumption_calculation',
							component: 'consumption_calculation',
						},
						{
							title: 'consumption_hierarchy',
							component: 'consumption_hierarchy',
							test_user: true,
						},
						{ title: 'device_name', component: 'device_name_g2' },
						{ title: 'pin_lock', component: 'pin_lock' },
						{ title: 'input_state', component: 'input_state' },
						{ title: 'exclude_event_log', component: 'exclude_event_log' },
						{
							title: 'exclude_forgotten_lights',
							component: 'exclude_forgotten_lights',
							premium: true,
						},
					],
				},
				webhooks_gen_2,
				share,
				{
					title: 'settings',
					components: [
						{ title: 'input_output', component: 'input_output_g2' },
						{
							title: 'enable_input',
							component: 'enable_input_g2',
							min_ver: '1.0.7',
						},
						{
							title: 'lock_inputs',
							component: 'lock_inputs_g2',
							min_ver: '1.6.0',
						},
						{ title: 'invert_switch', component: 'invert_switch_g2' },
						{ title: 'firmware_version', component: 'firmware_update' },
						{ title: 'geo_location_and_time_zone', component: 'location_g2' },
						{ title: 'device_reboot', component: 'device_reboot' },
						{ title: 'factory_reset', component: 'factory_reset' },
						{ title: 'device_information', component: 'device_information' },
					],
				},
			],
		},
	},
};
